import { api } from './authService';

export interface Employee {
  id: string;
  name: string;
  type: string;
  cpf: string;
  cnpj: string;
  role: string;
  valor_mensal: string;
  conta_despesa: string;
  conta_passivo: string;
  ativo: string;
}

export interface PaymentPreview {
  date: string;
  payee: string;
  postings: { account: string; amount: number; commodity: string }[];
  employee_id: string;
}

export async function getEmployees(): Promise<Employee[]> {
  const res = await api.get<Employee[]>('/employees');
  return res.data;
}

export async function getEmployee(id: string): Promise<Employee> {
  const res = await api.get<Employee>(`/employees/${encodeURIComponent(id)}`);
  return res.data;
}

export async function createEmployee(data: Partial<Employee> & { id: string; name: string; type: string }): Promise<Employee> {
  const res = await api.post<Employee>('/employees', data);
  return res.data;
}

export async function updateEmployee(id: string, data: Partial<Employee>): Promise<Employee> {
  const res = await api.put<Employee>(`/employees/${encodeURIComponent(id)}`, data);
  return res.data;
}

export async function deleteEmployee(id: string): Promise<Employee> {
  const res = await api.delete<Employee>(`/employees/${encodeURIComponent(id)}`);
  return res.data;
}

export async function payEmployee(
  id: string,
  data: { date?: string; valor?: string; descricao?: string; commit?: boolean },
): Promise<{ preview?: PaymentPreview; transaction?: any; committed: boolean }> {
  const res = await api.post(`/employees/${encodeURIComponent(id)}/pay`, data);
  return res.data;
}
